// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1bPc3","productName":"Table_productName__16U6n"};